import { render, staticRenderFns } from "./RoleBottomNav.vue?vue&type=template&id=77e3338a&scoped=true"
import script from "./RoleBottomNav.vue?vue&type=script&lang=js"
export * from "./RoleBottomNav.vue?vue&type=script&lang=js"
import style0 from "./RoleBottomNav.vue?vue&type=style&index=0&id=77e3338a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e3338a",
  null
  
)

export default component.exports